import { Button, Image, Text } from "@chakra-ui/react";
import React from "react";

interface CyberspaceButtonProps {
  label?: string;
  onClick: () => void;
  isLoading?: boolean;
}

/** Przycisk „Zaloguj się / Zweryfikuj przez Cyberspace" — biały, z ich logo. */
export const CyberspaceButton: React.FC<CyberspaceButtonProps> = ({ label = "Zaloguj się przez", onClick, isLoading }) => (
  <Button
    onClick={onClick}
    isLoading={isLoading}
    variant="outline"
    w="100%"
    h="auto"
    py="11px"
    bg="white"
    borderColor="rgba(61,10,112,0.25)"
    borderRadius="12px"
    flexDirection="column"
    gap="5px"
    transition="all 0.15s"
    _hover={{ bg: "rgba(61,10,112,0.05)", borderColor: "rgba(61,10,112,0.55)" }}
    _active={{ bg: "rgba(61,10,112,0.09)" }}
  >
    <Text fontSize="12px" fontWeight="600" color="gray.500" lineHeight="1">
      {label}
    </Text>
    <Image src="/cyberspace-logo.svg" alt="Cyberspace Portal" h="19px" />
  </Button>
);
